import styled from "styled-components";

export const TableContainerOverflow = styled.div`
  overflow: auto;
`;